import { getSearchApiBaseUrl } from "ui";
export { getSearchApiBaseUrl };

// Backend route that proxies fal.ai birefnet/v2 "Light" background removal
// (server-side so FAL_KEY never reaches the browser). Single source of truth for
// the path — consumed by both the chat fixed-material strip and the board-editor
// "Remove Background" button.
export const BG_REMOVAL_PATH = "/material-replacement/remove-backdrop";

export function getSearchApiAgentVersion(): string {
  return "v4";
}

/**
 * Returns the URL for the addMessage endpoint.
 * Uses the same base URL as the design-stream API.
 */
export function getAddMessageUrl(): string {
  return `${getSearchApiBaseUrl()}/addMessage`;
}

/** Undo endpoint for a concept (moves the head one step back). */
export function getConceptUndoUrl(conceptId: string): string {
  return `${getSearchApiBaseUrl()}/api/concept/${encodeURIComponent(conceptId)}/undo`;
}

/** Redo endpoint for a concept (restores the just-undone version). */
export function getConceptRedoUrl(conceptId: string): string {
  return `${getSearchApiBaseUrl()}/api/concept/${encodeURIComponent(conceptId)}/redo`;
}
